import { WSFilter } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayerFilterOptions } from "../../../../Payers/hooks/usePayerFilterOptions";

export function useBuildConfig() {
  const payerOptions = usePayerFilterOptions();

  return useMemo((): WSFilter[] => {
    const config: WSFilter[] = [];

    config.push({
      title: "Client",
      name: "payerId",
      type: "select",
      apiOptions: payerOptions
    });

    config.push({
      title: "Date range",
      name: "dateRange",
      type: "daterange",
      titleInLabel: true,
      options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
    });

    return config;
  }, [payerOptions]);
}
